import request from "@/http/axios";

export function confMon() {
  return request({
    url: "/telmonitor/conf/confMon",
    method: "POST",
    data: {}
  });
}

export function confMute(status) {
  return request({
    url: "/telmonitor/conf/muteConf",
    method: "POST",
    data: { status }
  });
}

export function confLock(status) {
  return request({
    url: "/telmonitor/conf/lockConf",
    method: "POST",
    data: { status }
  });
}

export function confRecord(status) {
  return request({
    url: "/telmonitor/conf/confRecordStatusUpdate",
    method: "POST",
    data: { status }
  });
}

export function confClose() {
  return request({
    url: "/telmonitor/conf/closeConf",
    method: "POST",
    data: {}
  });
}

export function partyMute(isMute, partyId) {
  return request({
    url: "/telmonitor/conf/muteParty",
    method: "POST",
    data: { isMute, partyId }
  });
}

export function muteMore(isMute, partyList) {
  return request({
    url: "/telmonitor/conf/muteMore",
    method: "POST",
    data: { isMute, partyList }
  });
}

export function partyHangup(partyId) {
  return request({
    url: "/telmonitor/conf/hangup",
    method: "POST",
    data: { partyId }
  });
}

export function confUpdateGuestMuteOverride(status) {
  return request({
    url: "/telmonitor/conf/guestMuteOverride",
    method: "POST",
    data: { status }
  });
}

export function callOut({
  phone,
  name,
  role,
  summit,
  countryCode,
  areaCode,
  company,
  department
}) {
  return request({
    url: "/telmonitor/conf/callout",
    method: "POST",
    data: {
      phone,
      name,
      role,
      summit,
      countryCode,
      areaCode,
      company,
      department
    }
  });
}

export function callOutOther(summit, partyList) {
  return request({
    url: "/telmonitor/conf/calloutOther",
    method: "POST",
    data: { summit, partyList }
  });
}

export function addOtherParty(summit, partyList) {
  return request({
    url: "/telmonitor/conf/addOtherParty",
    method: "POST",
    data: { summit, partyList }
  });
}

export function cancelCallout(summit, partyList) {
  return request({
    url: "/telmonitor/conf/cancelCallout",
    method: "POST",
    data: { summit, partyList }
  });
}

export function playWaitLine(status) {
  return request({
    url: "/telmonitor/conf/playWaitLine",
    method: "POST",
    data: { status }
  });
}

export function removeParties(summit, partyList) {
  return request({
    url: "/telmonitor/conf/removeParties",
    method: "POST",
    data: { summit, partyList }
  });
}

export function queryGroupList() {
  return request({
    url: "/telmonitor/conf/queryGroupList",
    method: "POST",
    data: {}
  });
}

export function queryContactList(groupId, type, keyword = "") {
  return request({
    url: "/telmonitor/conf/queryContactList",
    method: "POST",
    data: {
      groupId,
      type,
      keyword
    }
  });
}

export function queryContactListPage(keyword, page, num) {
  const groupId = -1;
  const type = 2;
  return request({
    url: "/telmonitor/conf/queryContactListPage",
    method: "POST",
    data: {
      groupId,
      type,
      keyword,
      page,
      num
    }
  });
}

export function queryMoreContactGroup(groupList) {
  return request({
    url: "/telmonitor/conf/queryMoreContactGroup",
    method: "POST",
    data: {
      groupList
    }
  });
}

export function updateRole(role, partyList) {
  return request({
    url: "/telmonitor/conf/updateRole",
    method: "POST",
    data: {
      role,
      partyList
    }
  });
}

export function saveToAddress(partyList) {
  return request({
    url: "/telmonitor/conf/saveToAddress",
    method: "POST",
    data: {
      partyList
    }
  });
}

export function updatePartyInfo(data) {
  return request({
    url: "/telmonitor/conf/updateParty",
    method: "POST",
    data
  });
}

export function getCurrentTime() {
  return request({
    url: "/telmonitor/conf/getCurrentTime",
    method: "POST"
  });
}
